const lbaResource = angular.module('app.lbaResource', []);

lbaResource.controller('lbaResourceCtrl', require('./lbaResourceCtrl'));
lbaResource.directive('lbaResource', require('./lbaResourceDir'));

export default lbaResource;



// WEBPACK FOOTER //
// ./src/components/lbaResource/index.js